import { EffectFunction } from './index.js';
import { Adslot } from '../modules/adslot-controller/adslot.js';

const sdgUnfilled: string = 'sdgUnfilled';

/**
 * legacy function for old stickyfooter script
 * https://github.com/mbrtargeting/stroeer-adformat-templates/blob/master/templates/Publisher_extern/StickySchlie%C3%9FenButton.html
 * Many publishers will have that script installed, before switching to the native functionality in metatag2
 * @param slotHull
 * @constructor
 */
export const MARK_HULL_AS_UNFILLED: EffectFunction = ({ slotHull }: Adslot) => {
    slotHull.classList.add(sdgUnfilled);
    return () => {
        slotHull?.classList.remove(sdgUnfilled);
    };
};
